const API_URL = process.env.REACT_APP_API_URL;

/**
 * The server verifies `credential` (Google ID token) or `access_token` with Google
 * and takes the email from Google's answer; the profile fields are display-only.
 */
export async function googleLoginRequest({
  credential,
  access_token,
  google_id,
  email,
  name = "",
  avatar = "",
  typeofuser,
  password,
  country,
  position,
}) {
  const body = {
    google_id,
    email,
    name,
    avatar,
  };
  if (credential) {
    body.credential = credential;
  }
  if (access_token) {
    body.access_token = access_token;
  }
  if (typeofuser) {
    body.typeofuser = typeofuser;
  }
  if (password) {
    body.password = password;
  }
  if (country) {
    body.country = country;
  }
  if (position) {
    body.position = position;
  }

  const res = await fetch(`${API_URL}/google-login.php`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(body).toString(),
  });
  return res.json();
}

export function persistForumUser(user) {
  localStorage.setItem("forumUser", JSON.stringify(user));
  localStorage.setItem("userEmail", user.email);
}

/**
 * Call Google login API. If the account is new, returns { needsAccountType, pending }.
 * If existing or created, returns { user }.
 * Pass signup details as the second argument: { typeofuser, password, country, position }.
 */
export async function resolveGoogleLogin(googleProfile, details = {}) {
  const { typeofuser, password, country, position } = details;
  const data = await googleLoginRequest({
    ...googleProfile,
    typeofuser,
    password,
    country,
    position,
  });

  if (data?.needs_account_type) {
    return {
      needsAccountType: true,
      // Keep the Google token so the sign-up step can be verified too.
      pending: { ...googleProfile, ...(data.pending || {}) },
      message: data.message,
    };
  }

  if (data?.success && data?.user) {
    return { user: data.user };
  }

  return {
    error: data?.message || "Google login failed",
  };
}
